import { tokens, type } from './tokens';

export const theme = {
  tokens,
  type,
} as const;

export type Theme = typeof theme;
